import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import Style from './modalToolbar.module.scss';
import { FC } from 'react';
import { ReactComponent as EditIcon } from 'src/assets/img/common/edit_20.svg';
import { ReactComponent as ExportIcon } from 'src/assets/img/common/export_20.svg';
import { DateFormats, localFormat } from 'src/helpers/date-helpers';
import { AppButton } from 'uikit/buttons';
import clsx from 'clsx';

export type ModalToolbarProps = {
  created: {
    at: Date;
    fullName: string;
  };
  updated: {
    at: Date;
    fullName: string;
  };
  onExport?: () => void;
  onEdit?: () => void;
  className?: string;
};

export const ModalToolbar: FC<ModalToolbarProps> = ({ onExport, onEdit, created, updated, className }) => {
  const { t } = useScopedTranslation('MonitoringForms.Overview.Modal');

  return (
    <div className={clsx(Style.toolbar, className)}>
      <div className={Style.leftPart}>
        <div className={Style.icon}>
          <EditIcon />
        </div>
        {created.at.getTime() === updated.at.getTime()
          ? t('Created', {
              date: localFormat(created.at, DateFormats.longDate),
              name: created.fullName,
            })
          : t('Edited', {
              date: localFormat(updated?.at, DateFormats.longDate),
              name: updated.fullName,
            })}
      </div>
      <div className={Style.rightPart}>
        {onExport && <AppButton Icon={ExportIcon} variant={'icon-link'} colorSchema={'primary'} onClick={onExport} />}
        {onEdit && <AppButton Icon={EditIcon} variant={'icon-link'} colorSchema={'primary'} onClick={onEdit} />}
      </div>
    </div>
  );
};
